import { useMutation } from "@apollo/client";
import { REGISTER_DEVICE } from "@/modules/user-settings/features/register-device/api/register-device";

export function useRegisterDeviceMutation() {
  const [register, { loading }] = useMutation(REGISTER_DEVICE);

  return {
    register,
    loading,
  };
}
